var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,12a1,1,0,0,1-.71-.29l-5-5a1,1,0,0,1,0-1.42l5-5A1,1,0,0,1,6.71,1.71L2.41,6l4.3,4.29a1,1,0,0,1,0,1.42A1,1,0,0,1,6,12Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack3);
export default __webpack_public_path__ + "static/media/back-3.1d2f8cccd80e71b74cab97be621521fc.svg";
export { ForwardRef as ReactComponent };